import { render } from "./ad-block.vue?vue&type=template&id=250f7858"
import script from "./ad-block.vue?vue&type=script&lang=js"
export * from "./ad-block.vue?vue&type=script&lang=js"

import "./ad-block.vue?vue&type=style&index=0&id=250f7858&lang=scss"

import exportComponent from "/Users/riccardosirchia/Projects/dryrobe.com-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__